import { DescriptorType } from '../context.type';

export const RepeatedDimType = {
  String: 'RepeatedString',
  Number: 'RepeatedNumber',
  Bool: 'RepeatedBool',
  Date: 'RepeatedDate',
  Object: 'RepeatedObject',
  Fix: 'RepeatedFix',
  Ip: 'RepeatedIp',
};

export const DimTypes = {
  String: 'String',
  Number: 'Number',
  Bool: 'Bool',
  Date: 'Date',
  Object: 'Object',
  Fix: 'Fix',
  Ip: 'Ip',
};

export enum FieldTypes {
  Measurement = 'Measurement',
}

export const FieldTypesMap = {
  [FieldTypes.Measurement]: FieldTypes.Measurement,
  [DescriptorType.TYPE_STRING]: DimTypes.String,
  [`[${DescriptorType.TYPE_STRING}]`]: RepeatedDimType.String,
  [DescriptorType.TYPE_DOUBLE]: DimTypes.Number,
  [`[${DescriptorType.TYPE_DOUBLE}]`]: RepeatedDimType.Number,
  [DescriptorType.TYPE_BOOL]: DimTypes.Bool,
  [`[${DescriptorType.TYPE_BOOL}]`]: RepeatedDimType.Bool,
  [DescriptorType.TYPE_INT32]: DimTypes.Number,
  [`[${DescriptorType.TYPE_INT32}]`]: RepeatedDimType.Number,
  [DescriptorType.TYPE_UINT32]: DimTypes.Number,
  [`[${DescriptorType.TYPE_UINT32}]`]: RepeatedDimType.Number,
  [DescriptorType.TYPE_ENUM]: DimTypes.String,
  [`[${DescriptorType.TYPE_ENUM}]`]: RepeatedDimType.String,
  DATE: DimTypes.Date,
  '["DATE"]': RepeatedDimType.Date,
  DATETIME: DimTypes.Date,
  '["DATETIME"]': RepeatedDimType.Date,
  MESSAGE: DimTypes.Object,
  '["MESSAGE"]': RepeatedDimType.Object,
  FIX: DimTypes.Fix,
  '["FIX"]': DimTypes.Fix,
  IP: DimTypes.Ip,
  '["IP"]': RepeatedDimType.Ip,
};
